import { render, staticRenderFns } from "./InspectionCategoryCard.vue?vue&type=template&id=cf91b27c&scoped=true&"
import script from "./InspectionCategoryCard.vue?vue&type=script&lang=js&"
export * from "./InspectionCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./InspectionCategoryCard.vue?vue&type=style&index=0&id=cf91b27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf91b27c",
  null
  
)

export default component.exports